import LegalDocument from "./components/Common/LegalDocument";
import PrivateRoute from "./components/Common/Routing/PrivateRouting";
import AboutPage from "./pages/FooterPages/AboutPage";
import ContactPage from "./pages/FooterPages/ContactPage";
import FrequentItemsList from "./pages/FrequentListPage";
import MenuPlan from "./pages/MenuPlanPage";
import NotFound from "./pages/NotFoundPage";
import RecipeEditorPage from "./pages/RecipeEditorPage";
import RecipePage from "./pages/RecipePage";
import RecipesPage from "./pages/RecipesPage";
import SharedMenuPlanPage from "./pages/SharedMenuPlanPage";
import ShoppingListPage from "./pages/ShoppingListPage";

const routes = [
  { path: "/", element: <RecipesPage /> },
  { path: "/recipes", element: <RecipesPage /> },
  { path: "/recipe/:id", element: <RecipePage /> },
  { path: "/recipe/add", element: <RecipeEditorPage /> },
  { path: "/recipe/edit/:id", element: <PrivateRoute><RecipeEditorPage /></PrivateRoute> },
  { path: "/shopping-list", element: <PrivateRoute><ShoppingListPage /></PrivateRoute> },
  { path: "/menu-plan", element: <PrivateRoute><MenuPlan /></PrivateRoute> },
  { path: "/menu-plan/shared/:shareId", element: <SharedMenuPlanPage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/privacyPolicy", element: <LegalDocument docType='privacyPolicy' /> },
  { path: "/termsOfService", element: <LegalDocument docType='termsOfService' /> },
  { path: "/frequent", element: <FrequentItemsList /> },

  { path: "*", element: <NotFound /> },
];

export default routes;
